import adminEn from './messages/en/admin.json';
import botEn from './messages/en/bot.json';
import commonEn from './messages/en/common.json';
import errorsEn from './messages/en/errors.json';
import partnerEn from './messages/en/partner.json';
import webEn from './messages/en/web.json';
import adminFr from './messages/fr/admin.json';
import botFr from './messages/fr/bot.json';
import commonFr from './messages/fr/common.json';
import errorsFr from './messages/fr/errors.json';
import partnerFr from './messages/fr/partner.json';
import webFr from './messages/fr/web.json';
import adminRw from './messages/rw/admin.json';
import botRw from './messages/rw/bot.json';
import commonRw from './messages/rw/common.json';
import errorsRw from './messages/rw/errors.json';
import partnerRw from './messages/rw/partner.json';
import webRw from './messages/rw/web.json';
/**
 * Every catalogue, statically imported so bundlers can see them. The shape is
 * exactly what i18next expects for `resources`.
 */
export const resources = {
    en: { common: commonEn, errors: errorsEn, bot: botEn, web: webEn, admin: adminEn, partner: partnerEn },
    rw: { common: commonRw, errors: errorsRw, bot: botRw, web: webRw, admin: adminRw, partner: partnerRw },
    fr: { common: commonFr, errors: errorsFr, bot: botFr, web: webFr, admin: adminFr, partner: partnerFr },
};
